import React from 'react';
import { Box, Button, Card, CardContent, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { DepotSummary, TenantProfile, UserAccount } from '../../../models/userManagement';

interface OverviewTabProps {
  tenants: TenantProfile[];
  users: UserAccount[];
  depots: DepotSummary[];
  loading: boolean;
  onRefresh: () => void;
}

const OverviewTab: React.FC<OverviewTabProps> = ({ tenants, users, depots, loading, onRefresh }) => {
  const metrics = [
    {
      label: 'Active Tenants',
      value: tenants.filter((tenant) => tenant.active).length,
    },
    {
      label: 'Users',
      value: users.length,
    },
    {
      label: 'Depots',
      value: depots.length,
    },
  ];

  return (
    <Stack spacing={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Overview</Typography>
        <Button variant="outlined" onClick={onRefresh} startIcon={loading ? <CircularProgress size={16} /> : undefined}>
          Refresh
        </Button>
      </Box>

      <Grid container spacing={2}>
        {metrics.map((metric) => (
          <Grid item xs={12} md={4} key={metric.label}>
            <Card variant="outlined">
              <CardContent>
                <Typography variant="caption" color="text.secondary">
                  {metric.label}
                </Typography>
                <Typography variant="h4">{metric.value}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default OverviewTab;
